import { render, staticRenderFns } from "./RouteTab.vue?vue&type=template&id=eff563c4&"
import script from "./RouteTab.vue?vue&type=script&lang=js&"
export * from "./RouteTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports